(function() {
  var CUTOFF_H = 11;
  var DELIVERY_DAYS = 4;
  var DAYS_FR = ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];
  var MONTHS_FR = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];

  function easterDate(y) {
    var a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),month=Math.floor((h+l-7*m+114)/31),day=(h+l-7*m+114)%31+1;
    return new Date(y,month-1,day);
  }

  function getFeries(y) {
    var easter = easterDate(y);
    function addDays(d,n){var r=new Date(d);r.setDate(r.getDate()+n);return r;}
    var dates = [
      new Date(y,0,1),new Date(y,4,1),new Date(y,4,8),new Date(y,6,14),
      new Date(y,7,15),new Date(y,10,1),new Date(y,10,11),new Date(y,11,25),
      addDays(easter,1),addDays(easter,39),addDays(easter,50)
    ];
    return dates.map(function(d){
      return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
    });
  }

  function isFerie(d,feries){
    var key=d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
    return feries.indexOf(key)!==-1;
  }

  function isOuvre(d,feries){var dow=d.getDay();return dow!==0&&dow!==6&&!isFerie(d,feries);}

  function nextOuvre(d,feries,skip){
    var r=new Date(d);
    if(skip)r.setDate(r.getDate()+skip);
    while(!isOuvre(r,feries)){r.setDate(r.getDate()+1);}
    return r;
  }

  function addOuvres(d,n,feries){
    var r=new Date(d),added=0;
    while(added<n){r.setDate(r.getDate()+1);if(isOuvre(r,feries))added++;}
    return r;
  }

  function fmt(d){
    return DAYS_FR[d.getDay()]+' '+d.getDate()+' '+MONTHS_FR[d.getMonth()];
  }

  window.pbShippingMsg = function() {
    var now = new Date();
    var y = now.getFullYear();
    var feries = getFeries(y).concat(getFeries(y+1));

    if(isOuvre(now,feries) && now.getHours() < CUTOFF_H) {
      var livraison = addOuvres(now, DELIVERY_DAYS, feries);
      return 'Commandez avant 11h — expédié <strong>aujourd\'hui</strong>, livré aux alentours du <strong>'+fmt(livraison)+'</strong>';
    } else {
      var expedition;
      if(isOuvre(now,feries) && now.getHours() >= CUTOFF_H) {
        expedition = nextOuvre(now, feries, 1);
      } else {
        expedition = nextOuvre(now, feries, 0);
        if(expedition.toDateString() === now.toDateString()) {
          expedition = nextOuvre(now, feries, 1);
        }
      }
      var livraison2 = addOuvres(expedition, DELIVERY_DAYS, feries);
      return 'Expédié le <strong>'+fmt(expedition)+'</strong> — livré aux alentours du <strong>'+fmt(livraison2)+'</strong>';
    }
  };

  function buildMsg(cart) {
    var items = cart.items || [];
    var gcCount = items.reduce(function(acc, i){ return acc + (!i.requires_shipping ? i.quantity : 0); }, 0);
    var physCount = items.reduce(function(acc, i){ return acc + (i.requires_shipping ? i.quantity : 0); }, 0);
    var allGc = gcCount > 0 && physCount === 0;
    var mixed = gcCount > 0 && physCount > 0;
    var gcLabel = gcCount > 1 ? 'E-cartes cadeaux' : 'E-carte cadeau';

    if (allGc) {
      return '🎁 <strong>' + gcLabel + '</strong> — envoyée' + (gcCount > 1 ? 's' : '') + ' par email dès validation de ta commande.';
    } else if (mixed) {
      return window.pbShippingMsg()
        + '<br>🎁 <strong>' + gcLabel + '</strong> — envoyée' + (gcCount > 1 ? 's' : '') + ' par email dès validation de ta commande.';
    } else {
      return window.pbShippingMsg();
    }
  }

  function initAll() {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
      var msg = buildMsg(cart);
      document.querySelectorAll('[data-pb-shipping]').forEach(function(el) {
        el.innerHTML = msg;
      });
    }).catch(function() {
      document.querySelectorAll('[data-pb-shipping]').forEach(function(el) {
        el.innerHTML = window.pbShippingMsg();
      });
    });
  }

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('cart:updated', initAll);
  document.addEventListener('cart-drawer:open', initAll);

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if(node.nodeType === 1) {
          var els = node.querySelectorAll ? node.querySelectorAll('[data-pb-shipping]') : [];
          if(els.length > 0 || (node.dataset && node.dataset.pbShipping !== undefined)) {
            initAll();
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();